<!-- 全局查询 -->
<template>
    <div class="mobile-more-details">
        <div class="header">
             <span class="go-back" @click="goBack()">
                        <i class="iconfont icon-fanhui"></i>
                        <span>返回</span>
             </span>
            <span class="name">{{landinfo.dkmc}}</span>
<!--            <span class="right">-->
<!--                <i class="iconfont icon-guanbi"></i>-->
<!--            </span>-->
        </div>
        <div class="details">
            <el-scrollbar style="width: 100%;height: 100%;">
                <div>
                    <div class="details-content">
                        <div class="information-img" id="information-img">
                           <div v-show="qjtShow" style="width: 100%;height: 100%;">
                                   <!--   <photosphereviewer v-if="!ismobile" :tableImgHeight="'10rem'" :showphotespheremarker="true"  :navbarStatusArray="navbarStatusArray" :landinfo ="landinfo" ></photosphereviewer> -->
                                     <mobilephotosphereviewer v-if="true" :changeTxt="true" :tableImgHeight="'10rem'" :showphotespheremarker="true"  :navbarStatusArray="navbarStatusArray" :landinfo ="landinfo" ></mobilephotosphereviewer>

                                </div>
                                <div v-show="!qjtShow" class="no-data">
                                    <i class="iconfont icon-zanwutupian"></i>
                                </div>
                               <!--   <div v-show="qjtShow" class="img-button" @click="expand">
                                        <i class="iconfont icon-quanping"></i>
                                 </div> -->
                                <div class="time" v-show="qjtShow">
                                    <span>示意图拍摄时间：{{landinfo.qjtpsDate}}</span>
                                </div>
                        </div>
                        <div class="location-area">
                            <div>
                                <i class="iconfont icon-dingwei"></i>
                                <span>{{landinfo.dkdz}}</span>
                            </div>
                            <div>
                                <i class="iconfont icon-mianji"></i>
                                <span><span class="num">{{dkmj}}</span>亩</span>
                            </div>
                        </div>
                        <div class="other">
                            <el-row>
                                <el-col :span="12">
                                    <span>行政区</span>
                                    <span>{{landinfo.xzqmc}}</span>
                                </el-col>
                                <el-col :span="12">
                                    <span>地块面积</span>
                                    <span>{{dkmj}}亩</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <span>具体用途</span>
                                    <el-tooltip class="item" effect="dark" :content="landinfo.tdyt" placement="top">
                                    <span>{{landinfo.tdyt}}</span>
                                    </el-tooltip>
                                </el-col>
                                <el-col :span="12">
                                    <span>容积率</span>
                                    <span>{{landinfo.rjl}}</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <span>拟供地方式</span>
                                    <span>{{landinfo.gdfs}}</span>
                                </el-col>
                                <el-col :span="12">
                                    <span>拟供地时间</span>
                                    <span>{{landinfo.gdDate}}</span>
                                </el-col>
                            </el-row>
                          <!--   <el-row>
                                <el-col :span="12">
                                    <span>是否标准地</span>
                                    <span>暂无</span>
                                </el-col>
                                <el-col :span="12">
                                    <span>工业园区</span>
                                    <span>暂无</span>
                                </el-col>
                            </el-row> -->
                        </div>
                        <div class="contact clearfix">
                            <div class="left photo">
                                <img src="@/assets/images/mapView/DefTX.png" alt=""/>
                            </div>
                            <div class="contact-information">
                                <div class="name">
                                    <span>联系人</span>
                                    <span>{{landinfo.lxr}}</span>
                                </div>
                                <div class="iphone">
                                    <span>联系电话</span>
                                    <span>{{landinfo.lxdh}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="recommendation">
                            <div class="name">
                                推介说明
                            </div>
                            <div class="recommendation-content">
                                <span>{{landinfo.tjsm}}</span>
                            </div>
                        </div>
                        <div class="code">
                            <div class="name">专属土地码</div>
                            <div class="code-img">
                                 <img :src="ewmUlr" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div class="complete-conditions">
                        <div class="complete">
                            <div class="title">周边配套</div>
                            <div class="complete-content">
                                <ul>
                                    <li v-for="(item, index) in list" :key="'list'+index">
                                        <div class="name">
                                            <span :style="'background:'+ item.color" class="icon">
                                                <i :class="'iconfont '+ item.icon "></i>
                                            </span>
                                            <span v-html="item.type"></span>
                                        </div>
                                        <div class="distance">
                                            <span v-show="item.children.length===0">暂无</span>
                                            <div v-for="(childrenItem, childrenIndex) in item.children" :key="'childrenItem'+ index+childrenIndex">距{{childrenItem.itmename}}：{{childrenItem.distance}}米</div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="conditions">
                            <div class="title">规划条件</div>
                            <div class="details-table">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style="width: 5rem;">出让面积(亩)</td>
                                            <td>{{dkmj}}</td>
                                        </tr>
                                        <tr>
                                            <td>使用年限(年)</td>
                                            <td>{{landinfo.crnx}}</td>
                                        </tr>
                                        <tr>
                                            <td>容积率</td>
                                            <td>{{landinfo.rjl}}</td>
                                        </tr>
                                        <tr>
                                            <td>建筑密度(%)</td>
                                            <td>{{landinfo.jzmd}}</td>
                                        </tr>
                                        <tr>
                                            <td>建筑限高(米)</td>
                                            <td>{{landinfo.jzxg}}</td>
                                        </tr>
                                        <tr>
                                            <td>其他条件</td>
                                            <td>{{landinfo.qt}}</td>
                                        </tr>
                                         <tr>
                                        <td>社区配套</td>
                                        <td>{{landinfo.sqpt}}</td>
                                    </tr>
                                    <tr>
                                        <td>养老配套</td>
                                        <td>{{landinfo.ylpt}}</td>
                                    </tr>
                                    <tr>
                                        <td>教育配套</td>
                                        <td>{{landinfo.jypt}}</td>
                                    </tr>
                                    <tr>
                                        <td>其他配套</td>
                                        <td>{{landinfo.qtpt}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="conditions-content">
                                 <div v-for="(Item, index) in ghfjArray" :key="'childrenItem'+ index">
                                     <img width="100%" :src="Item.url" alt=""/>
                                </div>
                            </div>
                        </div>
                       <!--  <div class="planning">
                            <div class="title">规划配套</div>
                            <div class="details-table">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td style="width: 4rem;">社区配套</td>
                                        <td>{{landinfo.sqpt}}</td>
                                    </tr>
                                    <tr>
                                        <td>养老配套</td>
                                        <td>{{landinfo.ylpt}}</td>
                                    </tr>
                                    <tr>
                                        <td>教育配套</td>
                                        <td>{{landinfo.jypt}}</td>
                                    </tr>
                                    <tr>
                                        <td>其他配套</td>
                                        <td>{{landinfo.qtpt}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div> -->
                        <div class="transfer">
                            <div class="title">出让信息</div>
                            <div class="details-table">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td style="width: 5.5rem;">网挂地块编号</td>
                                        <td>{{landinfo.dkbh}}</td>
                                    </tr>
                                    <tr>
                                        <td>竞得人</td>
                                        <td>{{landinfo.jdr}}</td>
                                    </tr>
                                    <tr>
                                        <td>成交价(万元)</td>
                                        <td>{{landinfo.cjj}}</td>
                                    </tr>
                                    <tr>
                                        <td>竞得日期</td>
                                        <td>{{landinfo.jdDate}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-content">到底线了哟～</div>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import {mapResourceApi} from '@/api/mapResourceApi'
import QRCode from 'qrcode'
import { Notification } from 'element-ui'
import photosphereviewer from 'components/main-map/photosphereviewer'
import mobilephotosphereviewer from 'components/main-map/mobilephotosphereviewer'
import areaBG from '@/assets/images/mapView/location.png'
import recommendationBG from '@/assets/images/mapView/recommendation.png'
import {mapmanager, xzqUtils} from '@/views/class/mapmanager'

export default {
  components: {
    photosphereviewer,
    mobilephotosphereviewer
  },
  data() {
    return {
      navbarStatusArray: ['fullscreen'],
      showphotoSphereViewer: false,
      dkmj: 0,
      drawData: [],
      sphereCorrection: { pan: 0, tilt: 0, roll: 98 },
      resultlistShow: false,
      mapExpand: false,
      areaBG,
      recommendationBG,
      landinfo: {},
      list: [],
      moreDetailsTabsValue: 'ZBPT',
      ghfjArray: [],
      ewmUlr: '',
      qjtShow: false,
      fromList: false,
      feature: null,
      ismobile: true,
      photosphereviewerFlag: false
    }
  },
  watch: {
  },
  activated() {
    //
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    //
    this.photosphereviewerFlag = false
    setTimeout(() => {
      this.photosphereviewerFlag = true
    }, 300)
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    debugger
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
    const localhostPaht = location.href
    const index = localhostPaht.lastIndexOf('/')
    const dkid = localhostPaht.substr(index + 1, localhostPaht.length)
    const _this = this
    const params = {
      id: dkid
    }
    if (dkid === 'mobileindex') {
      return
    }
    xzqUtils.initXZQList()
    console.log(dkid)
    _this.getMoredetails(params)
  },
  methods: {
    getMoredetails(params) {
      this.ghfjArray = []
      mapResourceApi.getLandInfoAndMatchingById(params).then(response => {
        if (response.code === '200' && response.data) {
          this.landinfo = response.data.landinfo
          this.landinfo.ydxzmc = mapmanager.getYdxzName(this.landinfo.ydxz)
          this.landinfo.xzqmc = xzqUtils.getXZQNAME(this.landinfo.xzq)
          const mj = this.landinfo.dkmj
          this.dkmj = mj.toFixed(2)

          this.photespheremarkerlist = response.data.photespheremarkerlist
          this.landinfo.photespheremarkerlist = response.data.photespheremarkerlist
          this.list = response.data.list
          this.showphotoSphereViewer = true

          if (this.landinfo.ghfj) {
            const fjArray = this.landinfo.ghfj.split('&')
            for (let index = 0; index < fjArray.length; index++) {
              const element = fjArray[index]
              const oject = {}
              oject.url = `${gisserverUrl}` + element
              this.ghfjArray.push(oject)
            }
          }
          this.initViewer(this.landinfo.qjt)
          this.getEwm()
        } else {
          Notification.warning({
            title: '警告',
            message: '加载更多详情数据出错...',
            type: 'warning'
          })
        }
      })
    },
    settingData(feature, bool) {
      this.fromList = bool
      const params = {
        id: feature.properties.id
      }
      this.feature = feature
      mapmanager.zooomIn(this.feature)
      this.getMoredetails(params)
    },
    goBack() {
      this.$parent.resultExpand = false
      if (this.fromList) {
        this.$parent.componentShow = 'mapSearchResultsList'
        mapmanager.markerSelectedHandler(this.feature.index, false)
      } else {
        /*  this.$router.go(-1) */
        this.$router.push(
          {name: 'mobileindex'}
        )
      }
    },
    getEwm() {
      const _this = this
      const localhostPaht = window.document.location.origin
      const url = localhostPaht + '/mobileMoreDetails/' + this.landinfo.id
      console.log(url)
      QRCode.toDataURL(url)
        .then(url => {
          _this.ewmUlr = url
        })
        .catch(err => {
          console.error(err)
        })
    },
    initViewer(qjt) {
      if (qjt) {
        this.qjtShow = true
      } else {
        this.qjtShow = false
      }
    },
    expand() {
      this.mapExpand = true
    },
    narrowClick() {
      this.mapExpand = false
    }
  }
}
</script>
<style lang="scss" scoped>
    .mobile-more-details{
        width: 100%;
        height: 100%;
        text-align: left;
        .header{
            height: 2.2rem;
            line-height: 2.105rem;
            padding: 0rem 0.5rem;
            font-size: 0.7rem;
            text-align: center;
            border-bottom: 0.05rem solid #dedede;
            white-space: nowrap;
            overflow-x: auto;
            width: 100%;
            .go-back{
                    height: 1.2rem;
                    background: #4293f4;
                    border-radius: 0.2rem;
                    color: #ffffff;
                    cursor: pointer;
                    line-height: 1.2rem;
                    padding: 0px 0.4rem;
                    display: inline-block;
                    margin-right: 0.5rem;
                    float: left;
                    margin-top: 0.45rem;
                    i.iconfont{
                        font-size: 0.7rem;
                    }
            }
            .name{
                width: calc(100% - 3.4rem);
                text-align: center;
                display: inline-block;
            }
        }
        .details{
            width: 100%;
            height: calc(100% - 2.2rem);
            .details-content{
                padding: 0.5rem;
                border-bottom: 0.5rem solid #f7f8fa;
                .information-img{
                    width: 100%;
                    height: 10rem;
                    position: relative;
                    .time{
                        position: absolute;
                        left: 0.5rem;
                        top: 0.5rem;
                        z-index: 10;
                        background: rgba(0,0,0,0.5);
                        padding:0.3rem 0.5rem;
                        color: #fff;
                        font-size: 0.7rem;
                        border-radius: 0.2rem;
                    }
                    .img-button{
                        width: 1.4rem;
                        height: 1.4rem;
                        background: rgba(0,0,0,0.5);
                        border-radius: 50%;
                        position: absolute;
                        top: 0.6rem;
                        right: 0.6rem;
                        text-align: center;
                        line-height: 1.4rem;
                        cursor: pointer;
                        i.iconfont{
                            font-size: 0.7rem;
                            color: #fff;
                        }
                    }
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .no-data{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #F2F5F6;
                        border-radius: 4px;
                        i.iconfont{
                            color: #D0DCE5;
                            font-size: 56px;
                            text-align: center;
                        }
                    }
                }
                .location-area{
                    margin: 0.5rem 0rem;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    >div{
                        color: #333333;
                        font-size: 0.7rem;
                        i.iconfont{
                            font-size: 0.7rem;
                        }
                        .num{
                            color: #CC0101;
                            margin: 0rem 0.25rem;
                        }
                    }
                }
                .other{
                    background: #fafafa;
                    padding: 0.5rem;
                    line-height: 1.2rem;
                    .el-row{
                        position: unset;
                        span {
                            font-size: 0.7rem;
                            display: inline-block;
                            &:first-child {
                                color: #999999;
                                margin-right: 0.3rem;
                                width: 3.5rem;
                                text-align: right;
                                vertical-align: middle;
                            }
                            &:last-child {
                                color: #333;
                                width: calc(100% - 3.8rem);
                                white-space: nowrap;
                                overflow-x: auto;
                                vertical-align: middle;
                            }
                        }
                    }
                }
                .contact{
                    padding: 0.5rem;
                    border-bottom: 0.1rem solid #f7f8fa;
                    .photo{
                        width: 2rem;
                        height: 2rem;
                        border-radius: 50%;
                        overflow: hidden;
                        margin-right: 0.4rem;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .contact-information{
                        span{
                            font-size: 0.7rem;
                            &:first-child{
                                color: #999999;
                                width: 3rem;
                                display: inline-block;
                                margin-right: 0.35rem;
                                text-align: right;
                                line-height: 1rem;
                            }
                            &:last-child{
                                color: #333;
                                display: inline-block;
                                line-height: 1rem;
                            }
                        }
                    }
                }
                .recommendation{
                    margin: 0.5rem 0rem;
                    border-bottom: 0.1rem solid #f7f8fa;
                    padding-bottom: 0.5rem;
                    .name{
                        font-size: 0.7rem;
                        color: #999999;
                        margin-bottom: 0.25rem;
                    }
                    .recommendation-content{
                        font-size: 0.7rem;
                        color: #545864;
                    }
                }
                .code{
                    margin: 0.5rem 0rem;
                    .name{
                        font-size: 0.7rem;
                        color: #999999;
                        margin-bottom: 0.5rem;
                    }
                    .code-img{
                        width: 4.9rem;
                        height: 4.9rem;
                        margin: 0 auto;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
            .complete-conditions{
                margin: 0.5rem 0rem 0rem;
                .title{
                    height: 1.2rem;
                    padding-left: 0.75rem;
                    border-left: 0.25rem solid #2F80ED;
                    font-size: 0.9rem;
                    font-weight: 700;
                    color: #333333;
                    margin-bottom: 0.5rem;
                }
                .complete{
                    border-bottom: 0.5rem solid #f7f8fa;
                    padding-bottom: 0.5rem;
                    .complete-content{
                        margin-top: 0.5rem;
                        border-top: 0.05rem solid #f7f8fa;
                        border-radius: 0.2rem;
                        li{
                            padding: 0.5rem 0.5rem 0rem;
                            .name{
                                margin-bottom: 0.3rem;
                                font-size: 0.7rem;
                                font-weight: 700;
                                color: #333333;
                                line-height: 1rem;
                                .icon{
                                    width: 1rem;
                                    height: 1rem;
                                    border-radius: 50%;
                                    text-align: center;
                                    line-height: 1rem;
                                    display: inline-block;
                                    margin-right: 0.5rem;
                                    vertical-align: middle;
                                    i.iconfont{
                                        font-size: 0.6rem;
                                        color: #fff;
                                    }
                                }
                                span{
                                    &:last-child{
                                        vertical-align: middle;
                                    }
                                }
                            }
                            .distance{
                                background: #f7f8fa;
                                padding: 0.5rem;
                                font-size: 0.7rem;
                                color: #333333;
                                line-height: 1.25rem;
                                >div{
                                    white-space: nowrap;
                                    overflow-x: auto;
                                }
                            }
                        }
                    }
                }
                .conditions{
                    border-bottom: 0.5rem solid #f7f8fa;
                    margin-top: 0.5rem;
                    .conditions-content{
                        padding: 0.5rem;
                        overflow: auto;
                    }
                }
                .planning{
                    margin-top: 0.5rem;
                    border-bottom: 0.5rem solid #f7f8fa;
                    padding-bottom: 0.5rem;
                }
                .transfer{
                    margin-top: 0.5rem;
                    padding-bottom: 0.5rem;
                }
                .details-table{
                    padding: 0px 0.5rem;
                    table{
                        width: 100%;
                        border-collapse:collapse;
                        border-spacing:0;
                        td{
                            font-size: 0.7rem;
                            border: 1px solid #e1e1e1;
                            border-left: none;
                            border-right: none;
                            padding: 0.5rem;
                            &:nth-child(odd){
                                color: #999999;
                            }
                            &:nth-child(even){
                                color: #333;
                            }
                        }
                    }
                }
            }
            .bottom-content{
                height: 2.5rem;
                background: #f7f8fa;
                text-align: center;
                line-height: 2.5rem;
                font-size: 12px;
                color: #999999;
            }
            ::v-deep{
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
            }
        }
    }
</style>
